/* GENERATED by tools/dc-port from design-reference/PointFive OS Original.dc.html — DOM-faithful view.
 * Do not hand-edit layout/style literals; regenerate with `pnpm --filter @pointfive/dc-port port`. */
import { Fragment } from 'react';
import * as dc from '@/lib/dc';
import type { ViewModel } from './view-model';

export function JournalView({ m }: { m: ViewModel }) {
  return (
    <div style={{ padding: '20px 12px 40px', display: 'flex', flexDirection: 'column', gap: '14px' }}>
      {' '}
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
        {' '}
        <button
          className="scp-4f3e86a"
          onClick={m.jUp}
          title="Zoom out one level"
          aria-label="Zoom out one level"
          style={{
            width: '26px',
            height: '26px',
            borderRadius: '9px',
            border: '1px solid var(--l8)',
            background: 'transparent',
            color: 'var(--faint)',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <i className="ph ph-arrow-up-left" style={{ fontSize: '13px' }}></i>
        </button>{' '}
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap' }}>
          {' '}
          {(m.jCrumb ?? []).map((c, i123) => (
            <Fragment key={i123}>
              {' '}
              <button
                className="scp-c0a65d4"
                onClick={c?.go}
                aria-label={`Go to ${dc.s(c?.label)}`}
                style={dc.css(
                  `border:none;background:transparent;color:${dc.s(c?.fg)};font-weight:${dc.s(c?.fw)};font-size:12.5px;cursor:pointer;padding:0`,
                )}
              >
                {dc.t(c?.label)}
              </button>{' '}
            </Fragment>
          ))}{' '}
        </div>{' '}
        <div style={{ flex: '1' }}></div>{' '}
        {m.jLevelIsYear ? (
          <>
            {' '}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '2px',
                padding: '2px',
                borderRadius: '99px',
                border: '1px solid var(--l8)',
              }}
            >
              {' '}
              <button
                className="scp-4f3e86a"
                onClick={m.jPrevYear}
                title="Previous year"
                aria-label="Previous year"
                style={{
                  width: '26px',
                  height: '26px',
                  border: 'none',
                  background: 'transparent',
                  color: 'var(--muted)',
                  cursor: 'pointer',
                  borderRadius: '99px',
                }}
              >
                <i className="ph ph-caret-left" style={{ fontSize: '13px' }}></i>
              </button>{' '}
              <span
                style={{
                  fontSize: '11.5px',
                  fontWeight: '600',
                  padding: '0 10px',
                  fontVariantNumeric: 'tabular-nums',
                }}
              >
                {dc.t(m.jYearLabel)}
              </span>{' '}
              <button
                className="scp-4f3e86a"
                onClick={m.jNextYear}
                title="Next year"
                aria-label="Next year"
                style={{
                  width: '26px',
                  height: '26px',
                  border: 'none',
                  background: 'transparent',
                  color: 'var(--muted)',
                  cursor: 'pointer',
                  borderRadius: '99px',
                }}
              >
                <i className="ph ph-caret-right" style={{ fontSize: '13px' }}></i>
              </button>{' '}
            </div>{' '}
          </>
        ) : null}{' '}
      </div>{' '}
      <div
        style={{
          background: 'var(--surface)',
          border: '1px solid var(--card-line)',
          boxShadow: 'var(--shadow-card)',
          borderRadius: '16px',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit,minmax(min(50%,150px),1fr))',
        }}
      >
        {' '}
        {(m.jScopeStats ?? []).map((s, i124) => (
          <Fragment key={i124}>
            {' '}
            <div style={{ padding: '13px 16px', borderRight: '1px solid var(--l6)' }}>
              <div
                style={{
                  fontSize: '9px',
                  letterSpacing: '0.11em',
                  textTransform: 'uppercase',
                  color: 'var(--muted2)',
                  fontWeight: '600',
                }}
              >
                {dc.t(s?.k)}
              </div>
              <div
                style={dc.css(
                  `font-size:17px;font-weight:600;letter-spacing:-0.02em;color:${dc.s(s?.c)};margin-top:4px;font-variant-numeric:tabular-nums`,
                )}
              >
                {dc.t(s?.v)}
              </div>
            </div>{' '}
          </Fragment>
        ))}{' '}
      </div>{' '}
      {m.jLevelIsYear ? (
        <>
          {' '}
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%,190px),1fr))',
              gap: '12px',
            }}
          >
            {' '}
            {(m.jYearMonths ?? []).map((m, i125) => (
              <Fragment key={i125}>
                {' '}
                <button
                  className="scp-c3ce304"
                  onClick={m?.go}
                  aria-label={`Open ${dc.s(m?.full)}`}
                  style={dc.css(
                    `background:var(--surface);color:var(--text);border:1px solid ${dc.s(m?.bd)};box-shadow:var(--shadow-card);border-radius:16px;padding:13px 15px;text-align:left;cursor:pointer`,
                  )}
                >
                  {' '}
                  <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px' }}>
                    <span style={{ fontSize: '12.5px', fontWeight: '600' }}>{dc.t(m?.full)}</span>
                    <div style={{ flex: '1' }}></div>
                    <span
                      style={dc.css(
                        `font-size:12px;font-weight:600;color:${dc.s(m?.pnlFg)};font-variant-numeric:tabular-nums`,
                      )}
                    >
                      {dc.t(m?.pnl)}
                    </span>
                  </div>{' '}
                  <div
                    style={{
                      height: '4px',
                      borderRadius: '99px',
                      background: 'var(--l6)',
                      marginTop: '9px',
                      overflow: 'hidden',
                    }}
                  >
                    <div
                      style={dc.css(
                        `width:${dc.s(m?.w)};height:100%;border-radius:99px;background:${dc.s(m?.bar)}`,
                      )}
                    ></div>
                  </div>{' '}
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '8px' }}>
                    <span
                      style={{ fontSize: '10px', color: 'var(--muted2)', fontVariantNumeric: 'tabular-nums' }}
                    >
                      {dc.t(m?.trades)}
                    </span>
                    <div style={{ flex: '1' }}></div>
                    <span
                      style={{ fontSize: '10px', color: 'var(--sky)', fontVariantNumeric: 'tabular-nums' }}
                    >
                      {dc.t(m?.entries)}
                    </span>
                  </div>{' '}
                </button>{' '}
              </Fragment>
            ))}{' '}
          </div>{' '}
        </>
      ) : null}{' '}
      {m.jLevelIsYear ? (
        <>
          {' '}
          <div
            style={{
              background: 'var(--surface)',
              border: '1px solid var(--card-line)',
              boxShadow: 'var(--shadow-card)',
              borderRadius: '16px',
              padding: '16px 18px',
            }}
          >
            {' '}
            <div style={{ display: 'flex', alignItems: 'center', gap: '9px' }}>
              <span style={{ fontSize: '12.5px', fontWeight: '500' }}>
                {'Weeks in '}
                {dc.t(m.jMonthLabel)}
              </span>
              <div style={{ flex: '1' }}></div>
              <span style={{ fontSize: '10px', color: 'var(--muted2)' }}>
                Green = profit, red = loss, darker = larger · click a day to open it
              </span>
            </div>{' '}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '14px', marginTop: '14px' }}>
              {' '}
              {(m.jWeeks ?? []).map((w, i126) => (
                <Fragment key={i126}>
                  {' '}
                  <div
                    style={{
                      border: '1px solid var(--l8)',
                      borderRadius: '13px',
                      background: 'var(--l3)',
                      padding: '13px 15px',
                    }}
                  >
                    {' '}
                    <div style={{ display: 'flex', alignItems: 'baseline', gap: '10px', flexWrap: 'wrap' }}>
                      {' '}
                      <span style={{ fontSize: '12px', fontWeight: '600' }}>
                        {dc.t(w?.label)}
                        {' — '}
                        {dc.t(w?.range)}
                      </span>{' '}
                      <div style={{ flex: '1' }}></div>{' '}
                      <span
                        style={dc.css(
                          `font-size:12px;font-weight:600;color:${dc.s(w?.pnlFg)};font-variant-numeric:tabular-nums`,
                        )}
                      >
                        {dc.t(w?.pnl)}
                      </span>{' '}
                      <span style={{ fontSize: '10.5px', color: 'var(--muted2)' }}>
                        {'· '}
                        {dc.t(w?.trades)}
                        {' · '}
                        {dc.t(w?.wr)}
                      </span>{' '}
                    </div>{' '}
                    <div
                      style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(5,1fr)',
                        gap: '7px',
                        marginTop: '10px',
                      }}
                    >
                      {' '}
                      {(w?.cells ?? []).map((c, i127) => (
                        <Fragment key={i127}>
                          {' '}
                          <button
                            onClick={c?.go}
                            title={dc.a(c?.title)}
                            aria-label={dc.a(c?.label)}
                            disabled={!!c?.disabled}
                            style={dc.css(
                              `border:none;border-radius:11px;background:${dc.s(c?.bg)};padding:10px 8px;min-height:64px;display:flex;flex-direction:column;justify-content:space-between;cursor:${dc.s(c?.cur)};text-align:left;opacity:${dc.s(c?.opacity)}`,
                            )}
                          >
                            {' '}
                            <span
                              style={dc.css(
                                `font-size:10px;font-weight:600;font-variant-numeric:tabular-nums;color:${dc.s(c?.labelFg)}`,
                              )}
                            >
                              {dc.t(c?.label)}
                            </span>{' '}
                            <span
                              style={dc.css(
                                `font-size:10.5px;font-weight:600;font-variant-numeric:tabular-nums;color:${dc.s(c?.pnlFg)}`,
                              )}
                            >
                              {dc.t(c?.pnl)}
                            </span>{' '}
                          </button>{' '}
                        </Fragment>
                      ))}{' '}
                    </div>{' '}
                  </div>{' '}
                </Fragment>
              ))}{' '}
            </div>{' '}
          </div>{' '}
        </>
      ) : null}{' '}
      {m.jLevelIsDay ? (
        <>
          {' '}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
            {' '}
            <div
              style={{
                background: 'var(--surface)',
                border: '1px solid var(--card-line)',
                boxShadow: 'var(--shadow-card)',
                borderRadius: '16px',
                padding: '16px 18px',
                display: 'flex',
                alignItems: 'center',
                gap: '14px',
                flexWrap: 'wrap',
              }}
            >
              {' '}
              <div style={{ flex: '1', minWidth: '200px' }}>
                <div style={{ fontSize: '13.5px', fontWeight: '500' }}>{dc.t(m.jDayTitle)}</div>
                <div
                  style={{
                    fontSize: '10.5px',
                    color: 'var(--muted2)',
                    marginTop: '3px',
                    fontVariantNumeric: 'tabular-nums',
                  }}
                >
                  {dc.t(m.jDayCount)}
                </div>
              </div>{' '}
              <div style={{ textAlign: 'right' }}>
                <div
                  style={{
                    fontSize: '9px',
                    letterSpacing: '0.11em',
                    textTransform: 'uppercase',
                    color: 'var(--muted2)',
                    fontWeight: '600',
                  }}
                >
                  Day P&L
                </div>
                <div
                  style={dc.css(
                    `font-size:19px;font-weight:600;letter-spacing:-0.02em;color:${dc.s(m.jDayNetFg)};margin-top:2px;font-variant-numeric:tabular-nums`,
                  )}
                >
                  {dc.t(m.jDayNet)}
                </div>
              </div>{' '}
              {m.jHasJournal ? (
                <>
                  {' '}
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px',
                      paddingLeft: '14px',
                      borderLeft: '1px solid var(--l7)',
                    }}
                  >
                    {' '}
                    <i
                      className="ph-fill ph-smiley"
                      style={{ fontSize: '19px', color: 'var(--pos)' }}
                    ></i>{' '}
                    <div>
                      <div style={{ fontSize: '11.5px', fontWeight: '500' }}>{dc.t(m.jMood)}</div>
                      <div style={{ fontSize: '10px', color: 'var(--muted2)' }}>{dc.t(m.jEnergy)}</div>
                      <div
                        style={{
                          width: '70px',
                          height: '3px',
                          borderRadius: '99px',
                          background: 'var(--l6)',
                          marginTop: '4px',
                          overflow: 'hidden',
                        }}
                      >
                        <div
                          style={dc.css(`width:${dc.s(m.jEnergyW)};height:100%;background:var(--sky-fill)`)}
                        ></div>
                      </div>
                    </div>{' '}
                  </div>{' '}
                </>
              ) : null}{' '}
            </div>{' '}
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%,340px),1fr))',
                gap: '14px',
                alignItems: 'stretch',
              }}
            >
              {' '}
              <div
                style={{
                  background: 'var(--surface)',
                  border: '1px solid var(--card-line)',
                  boxShadow: 'var(--shadow-card)',
                  borderRadius: '16px',
                  padding: '16px 18px',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                {' '}
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '7px',
                    fontSize: '12.5px',
                    fontWeight: '500',
                  }}
                >
                  <i className="ph ph-sun" style={{ fontSize: '14px', color: 'var(--amb)' }}></i>Pre-session
                  preparation
                </div>{' '}
                <div style={{ fontSize: '10.5px', color: 'var(--muted2)', marginTop: '2px' }}>
                  Captured during Session Setup
                </div>{' '}
                <textarea
                  value={dc.v(m.jPrepNote)}
                  onChange={m.setJPrep}
                  placeholder="What are you looking for today, and what would make you stop?"
                  aria-label="Pre-session preparation notes"
                  style={{
                    width: '100%',
                    flex: '1',
                    minHeight: '104px',
                    resize: 'none',
                    marginTop: '11px',
                    padding: '9px 12px',
                    borderRadius: '10px',
                    border: '1px solid var(--l10)',
                    background: 'var(--fill)',
                    color: 'var(--text)',
                    fontSize: '11.5px',
                    outline: 'none',
                    lineHeight: '1.6',
                    fontFamily: 'inherit',
                  }}
                ></textarea>{' '}
              </div>{' '}
              <div
                style={{
                  background: 'var(--surface)',
                  border: '1px solid var(--card-line)',
                  boxShadow: 'var(--shadow-card)',
                  borderRadius: '16px',
                  padding: '16px 18px',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                {' '}
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '7px',
                    fontSize: '12.5px',
                    fontWeight: '500',
                  }}
                >
                  <i className="ph ph-moon" style={{ fontSize: '14px', color: 'var(--sky)' }}></i>Post-session
                  review
                </div>{' '}
                <div style={{ fontSize: '10.5px', color: 'var(--muted2)', marginTop: '2px' }}>
                  Written at Session Close
                </div>{' '}
                <textarea
                  value={dc.v(m.jPostNote)}
                  onChange={m.setJPost}
                  placeholder="What did you learn from today's session? Markdown is supported — ## for headings, **bold**, - for lists…"
                  aria-label="Post-session review"
                  style={{
                    width: '100%',
                    height: '104px',
                    resize: 'none',
                    marginTop: '11px',
                    padding: '9px 12px',
                    borderRadius: '10px',
                    border: '1px solid var(--l10)',
                    background: 'var(--fill)',
                    color: 'var(--text)',
                    fontSize: '11.5px',
                    outline: 'none',
                    lineHeight: '1.6',
                    fontFamily: 'inherit',
                  }}
                ></textarea>{' '}
                <div
                  style={{
                    fontSize: '10px',
                    color: 'var(--muted2)',
                    marginTop: '5px',
                    textAlign: 'right',
                    fontVariantNumeric: 'tabular-nums',
                  }}
                >
                  {dc.t(m.jPostWords)}
                </div>{' '}
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginTop: '9px' }}>
                  {' '}
                  {(m.jDayTags ?? []).map((t, i128) => (
                    <Fragment key={i128}>
                      <span
                        style={dc.css(
                          `font-size:10px;padding:3px 10px;border-radius:99px;border:1px solid ${dc.s(t?.bd)};color:${dc.s(t?.fg)}`,
                        )}
                      >
                        {dc.t(t?.label)}
                      </span>
                    </Fragment>
                  ))}{' '}
                </div>{' '}
                <div style={{ display: 'flex', gap: '7px', marginTop: '10px' }}>
                  {' '}
                  <input
                    value={dc.v(m.jTagInput)}
                    onChange={m.setJTagInput}
                    placeholder="e.g. fomo, revenge, clean-entry"
                    aria-label="Add a behaviour tag"
                    style={{
                      flex: '1',
                      minWidth: '0',
                      padding: '9px 12px',
                      borderRadius: '10px',
                      border: '1px solid var(--l10)',
                      background: 'var(--fill)',
                      color: 'var(--text)',
                      fontSize: '11.5px',
                      outline: 'none',
                    }}
                  />{' '}
                  <button
                    className="scp-40be81e"
                    onClick={m.jAddTag}
                    aria-label="Add tag"
                    style={{
                      fontSize: '11px',
                      padding: '7px 14px',
                      borderRadius: '99px',
                      border: '1px solid var(--l12)',
                      background: 'transparent',
                      color: 'var(--text-mid)',
                      cursor: 'pointer',
                    }}
                  >
                    Add tag
                  </button>{' '}
                </div>{' '}
              </div>{' '}
            </div>{' '}
            <div
              style={{
                background: 'var(--surface)',
                border: '1px solid var(--card-line)',
                boxShadow: 'var(--shadow-card)',
                borderRadius: '16px',
                overflow: 'hidden',
              }}
            >
              {' '}
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  padding: '12px 16px',
                  flexWrap: 'wrap',
                }}
              >
                {' '}
                <span style={{ fontSize: '12.5px', fontWeight: '500' }}>Trades</span>{' '}
                <span style={{ fontSize: '10.5px', color: 'var(--sky)', fontVariantNumeric: 'tabular-nums' }}>
                  {dc.t(m.jAttachCount)}
                </span>{' '}
                <div style={{ flex: '1' }}></div>{' '}
                <button
                  className="scp-4f3e86a"
                  onClick={m.jGrabShots}
                  title="Pull chart screenshots from the attached trades"
                  aria-label="Pull chart screenshots from the attached trades"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '6px',
                    fontSize: '11px',
                    padding: '5px 12px',
                    borderRadius: '99px',
                    border: '1px solid var(--l10)',
                    background: 'transparent',
                    color: 'var(--muted)',
                    cursor: 'pointer',
                  }}
                >
                  <i className="ph ph-download-simple" style={{ fontSize: '12px' }}></i>Pull screenshots
                </button>{' '}
              </div>{' '}
              {m.jDayHasTrades ? (
                <>
                  {' '}
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '0 16px 12px' }}>
                    {' '}
                    <span style={{ fontSize: '10px', color: 'var(--muted2)' }}>Group by</span>{' '}
                    <div
                      style={{
                        display: 'flex',
                        gap: '2px',
                        padding: '2px',
                        borderRadius: '99px',
                        border: '1px solid var(--l8)',
                      }}
                    >
                      {' '}
                      {(m.jGroupTabs ?? []).map((g, i129) => (
                        <Fragment key={i129}>
                          {' '}
                          <button
                            onClick={g?.go}
                            style={dc.css(
                              `padding:3px 10px;border-radius:99px;border:none;background:${dc.s(g?.bg)};color:${dc.s(g?.fg)};font-weight:${dc.s(g?.fw)};font-size:10px;cursor:pointer`,
                            )}
                          >
                            {dc.t(g?.label)}
                          </button>{' '}
                        </Fragment>
                      ))}{' '}
                    </div>{' '}
                  </div>{' '}
                  <div style={{ borderTop: '1px solid var(--l6)' }}>
                    {' '}
                    {(m.jDayGroups ?? []).map((grp, i130) => (
                      <Fragment key={i130}>
                        {' '}
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            padding: '8px 16px',
                            background: 'var(--l3)',
                            borderBottom: '1px solid var(--l6)',
                          }}
                        >
                          {' '}
                          <span style={{ fontSize: '10.5px', fontWeight: '600' }}>
                            {dc.t(grp?.label)}
                          </span>{' '}
                          <span
                            style={{
                              fontSize: '9.5px',
                              color: 'var(--muted2)',
                              fontVariantNumeric: 'tabular-nums',
                            }}
                          >
                            {dc.t(grp?.n)}
                          </span>{' '}
                          <div style={{ flex: '1' }}></div>{' '}
                          <span
                            style={dc.css(
                              `font-size:10.5px;font-weight:600;color:${dc.s(grp?.pnlFg)};font-variant-numeric:tabular-nums`,
                            )}
                          >
                            {dc.t(grp?.pnl)}
                          </span>{' '}
                        </div>{' '}
                        {(grp?.trades ?? []).map((t, i131) => (
                          <Fragment key={i131}>
                            {' '}
                            <div
                              style={{
                                padding: '10px 16px',
                                borderBottom: '1px solid var(--l8)',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '11px',
                                flexWrap: 'wrap',
                              }}
                            >
                              {' '}
                              <span
                                style={{
                                  fontSize: '11px',
                                  color: 'var(--muted)',
                                  fontVariantNumeric: 'tabular-nums',
                                  width: '42px',
                                  flex: 'none',
                                }}
                              >
                                {dc.t(t?.time)}
                              </span>{' '}
                              <span
                                style={{ fontSize: '11.5px', fontWeight: '500', width: '64px', flex: 'none' }}
                              >
                                {dc.t(t?.sym)}
                              </span>{' '}
                              <span
                                style={dc.css(
                                  `font-size:9px;font-weight:600;letter-spacing:0.06em;padding:2px 7px;border-radius:99px;background:${dc.s(t?.sideBg)};color:${dc.s(t?.sideFg)};flex:none`,
                                )}
                              >
                                {dc.t(t?.side)}
                              </span>{' '}
                              <span
                                style={{
                                  fontSize: '10.5px',
                                  color: 'var(--muted2)',
                                  flex: '1',
                                  minWidth: '100px',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap',
                                }}
                              >
                                {dc.t(t?.strat)}
                              </span>{' '}
                              <span
                                style={{
                                  fontSize: '10.5px',
                                  color: 'var(--muted2)',
                                  fontVariantNumeric: 'tabular-nums',
                                  flex: 'none',
                                }}
                              >
                                {dc.t(t?.lots)}L
                              </span>{' '}
                              <span
                                style={dc.css(
                                  `font-size:11.5px;font-weight:600;color:${dc.s(t?.pnlFg)};font-variant-numeric:tabular-nums;flex:none`,
                                )}
                              >
                                {dc.t(t?.pnl)}
                              </span>{' '}
                              <button
                                className="scp-4f3e86a"
                                onClick={t?.toggle}
                                title={dc.a(t?.attachLabel)}
                                aria-label={`${dc.s(t?.attachLabel)} ${dc.s(t?.sym)} to this entry`}
                                aria-pressed={dc.b(t?.attached)}
                                style={dc.css(
                                  `display:inline-flex;align-items:center;gap:5px;font-size:10px;padding:4px 10px;border-radius:99px;border:1px solid ${dc.s(t?.attachBd)};background:${dc.s(t?.attachBg)};color:${dc.s(t?.attachFg)};cursor:pointer;flex:none`,
                                )}
                              >
                                <i className={`ph ${dc.s(t?.attachIcon)}`} style={{ fontSize: '11px' }}></i>
                                {dc.t(t?.attachLabel)}
                              </button>{' '}
                            </div>{' '}
                          </Fragment>
                        ))}{' '}
                      </Fragment>
                    ))}{' '}
                  </div>{' '}
                </>
              ) : null}{' '}
              {m.jDayNoTrades ? (
                <>
                  {' '}
                  <div
                    style={{
                      padding: '24px',
                      textAlign: 'center',
                      borderTop: '1px solid var(--l6)',
                      fontSize: '11.5px',
                      color: 'var(--faint)',
                    }}
                  >
                    No trades on this day — the entry still counts as a journalled session
                  </div>{' '}
                </>
              ) : null}{' '}
            </div>{' '}
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%,320px),1fr))',
                gap: '14px',
                alignItems: 'start',
              }}
            >
              {' '}
              <div
                style={{
                  background: 'var(--surface)',
                  border: '1px solid var(--card-line)',
                  boxShadow: 'var(--shadow-card)',
                  borderRadius: '16px',
                  padding: '16px 18px',
                }}
              >
                {' '}
                <div style={{ fontSize: '12.5px', fontWeight: '500' }}>Strategies used</div>{' '}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '11px' }}>
                  {' '}
                  {(m.jDayStrats ?? []).map((s, i132) => (
                    <Fragment key={i132}>
                      {' '}
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '10px',
                          padding: '9px 12px',
                          borderRadius: '11px',
                          border: '1px solid var(--l8)',
                          background: 'var(--l3)',
                        }}
                      >
                        <span
                          style={{
                            fontSize: '11.5px',
                            flex: '1',
                            minWidth: '0',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {dc.t(s?.label)}
                        </span>
                        <span
                          style={{
                            fontSize: '10px',
                            color: 'var(--muted2)',
                            fontVariantNumeric: 'tabular-nums',
                          }}
                        >
                          {dc.t(s?.n)}
                        </span>
                        <span
                          style={dc.css(
                            `font-size:11.5px;font-weight:600;color:${dc.s(s?.pnlFg)};font-variant-numeric:tabular-nums`,
                          )}
                        >
                          {dc.t(s?.pnl)}
                        </span>
                      </div>{' '}
                    </Fragment>
                  ))}{' '}
                </div>{' '}
              </div>{' '}
              <div
                style={{
                  background: 'var(--surface)',
                  border: '1px solid var(--card-line)',
                  boxShadow: 'var(--shadow-card)',
                  borderRadius: '16px',
                  padding: '16px 18px',
                }}
              >
                {' '}
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <i className="ph ph-camera" style={{ fontSize: '14px', color: 'var(--muted)' }}></i>
                  <span style={{ fontSize: '12.5px', fontWeight: '500' }}>Screenshots</span>
                  <span
                    style={{
                      fontSize: '9.5px',
                      padding: '1px 7px',
                      borderRadius: '99px',
                      background: 'var(--l6)',
                      color: 'var(--muted)',
                      fontVariantNumeric: 'tabular-nums',
                    }}
                  >
                    {dc.t(m.jShotCount)}
                  </span>
                </div>{' '}
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginTop: '10px' }}>
                  {' '}
                  {(m.jShotLabels ?? []).map((l, i133) => (
                    <Fragment key={i133}>
                      {' '}
                      <button
                        onClick={l?.go}
                        aria-label={`Label ${dc.s(l?.label)}`}
                        style={dc.css(
                          `font-size:10px;padding:4px 11px;border-radius:99px;border:1px dashed ${dc.s(l?.bd)};background:${dc.s(l?.bg)};color:${dc.s(l?.fg)};cursor:pointer`,
                        )}
                      >
                        {dc.t(l?.label)}
                      </button>{' '}
                    </Fragment>
                  ))}{' '}
                </div>{' '}
                {m.jHasShots ? (
                  <>
                    {' '}
                    <div
                      style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%,120px),1fr))',
                        gap: '8px',
                        marginTop: '11px',
                      }}
                    >
                      {' '}
                      {(m.jShots ?? []).map((s, i134) => (
                        <Fragment key={i134}>
                          {' '}
                          <div
                            style={dc.css(
                              `border:1px solid ${dc.s(s?.bd)};background:${dc.s(s?.bg)};border-radius:11px;padding:8px;display:flex;flex-direction:column;gap:6px`,
                            )}
                          >
                            {' '}
                            <div
                              style={{
                                height: '56px',
                                borderRadius: '8px',
                                border: '1px solid var(--l8)',
                                background: 'var(--l4)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                              }}
                            >
                              <i
                                className="ph ph-chart-line"
                                style={{ fontSize: '16px', color: 'var(--ghost)' }}
                              ></i>
                            </div>{' '}
                            <span
                              style={dc.css(
                                `font-size:9.5px;color:${dc.s(s?.fg)};overflow:hidden;text-overflow:ellipsis;white-space:nowrap`,
                              )}
                            >
                              {dc.t(s?.name)}
                            </span>{' '}
                          </div>{' '}
                        </Fragment>
                      ))}{' '}
                    </div>{' '}
                  </>
                ) : null}{' '}
                {m.jNoShots ? (
                  <>
                    {' '}
                    <div style={{ fontSize: '11px', color: 'var(--faint)', marginTop: '11px' }}>
                      No screenshots yet.
                    </div>{' '}
                  </>
                ) : null}{' '}
                <button
                  className="scp-620a81c"
                  onClick={m.jPasteShot}
                  title="Paste screenshot from clipboard"
                  aria-label="Paste screenshot from clipboard"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '7px',
                    width: '100%',
                    marginTop: '11px',
                    padding: '9px',
                    borderRadius: '11px',
                    border: '1px dashed var(--l12)',
                    background: 'transparent',
                    color: 'var(--muted)',
                    fontSize: '11.5px',
                    cursor: 'pointer',
                  }}
                >
                  <i className="ph ph-clipboard-text" style={{ fontSize: '13px' }}></i>Paste screenshot from
                  clipboard
                </button>{' '}
              </div>{' '}
            </div>{' '}
            <button
              className="scp-84b4671"
              onClick={m.jSaveEntry}
              aria-label="Save journal entry"
              style={{
                alignSelf: 'flex-end',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '7px',
                fontSize: '12px',
                fontWeight: '500',
                padding: '9px 18px',
                borderRadius: '99px',
                border: '1px solid color-mix(in srgb, var(--sky-fill) 50%, transparent)',
                background: 'color-mix(in srgb, var(--sky-fill) 10%, transparent)',
                color: 'var(--sky)',
                cursor: 'pointer',
              }}
            >
              <i className="ph ph-check" style={{ fontSize: '13px' }}></i>Save entry
            </button>{' '}
          </div>{' '}
        </>
      ) : null}
    </div>
  );
}
